// Base host for Azure public blob resources (images + JSON under /publicresources).
//
// In local dev set REACT_APP_PUBLIC_RES_BASE_URL to the proxy gateway
// (e.g. http://localhost:8002) so browser fetches go through the gateway and
// avoid Azure Blob CORS. In prod the env var is unset and we fall back to the
// blob host directly, so production behaviour is unchanged.
const PUBLIC_RES_BASE_URL =
  process.env.REACT_APP_PUBLIC_RES_BASE_URL ||
  "https://filestoragedfs.blob.core.windows.net";

// Build an absolute URL for a public resource path.
// publicResourceUrl("publicresources/json/AssistedMode/contacts.json")
export const publicResourceUrl = (path) =>
  `${PUBLIC_RES_BASE_URL.replace(/\/$/, "")}/${String(path).replace(/^\//, "")}`;
